export class NumberUtils {
  public static convertTimeToString(
    hours: number,
    minutes: number,
    secondes: number,
  ): string {
    const h = NumberUtils.numberToLocaleString(hours);
    const m = NumberUtils.numberToLocaleString(minutes);
    const s = NumberUtils.numberToLocaleString(secondes);
    return `${h}:${m}:${s}`;
  }

  private static numberToLocaleString(x: number): string {
    return x.toLocaleString('FR-fr', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
  }
}
